module.exports = __webpack_public_path__ + "img/31.2d7c1252.png";